import { useEffect, useRef, useState } from "react";
import Image from "../Image";
import chatImage from "../../../assets/img/chat.svg";
import botImage from "../../../assets/img/bot.svg";
import { io } from "socket.io-client";
import styles from "./index.module.css";
import TypingLoader from "../loaders/typing";
import FormMail from "./formMail";
import traking from "../../../lib/event/tracker";

const ChatContainer = () => {
  const [room, setRoom] = useState("Axel");
  const [isOpen, setisOpen] = useState(false);
  const [socket, setsocket] = useState(null);
  const [tips, setTips] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [isWritting, setIsWriting] = useState(false);
  const messageListRef = useRef();
  const bottomRef = useRef();

  useEffect(() => {
    if (socket) return;
    if (!isOpen) return;
    if (room != "default") return;
    let socketTemp = io.connect(process.env.NEXT_PUBLIC_CHAT_URL);
    setsocket(socketTemp);
  }, [isOpen]);

  useEffect(() => {
    if (!socket) return;

    socket.on("message", (m) => {
      let temp = [...messages, { content: m, isMe: false }];
      setIsWriting(false);
      setMessages(temp);
    });

    socket.on("tips", (tips) => {
      setTips(tips);
    });

    socket.on("connection", () => {
      setMessages([]);
    });

    socket.on("disconnect", () => {
      let temp = [...messages];
      temp.push({ content: "Vous avez été déconnecté", info: true });
      setMessages(temp);
      setsocket(null);
      setTimeout(() => {
        setisOpen(false);
      }, 1000);
    });
  }, [socket, messages]);

  useEffect(() => {
    goBottom();
  }, [messages]);

  useEffect(() => {
    goBottom();
  }, [room]);

  const goBottom = () => {
    try {
      let target = bottomRef.current;
      target.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    } catch (error) {}
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let temp = [...messages];
    temp.push({ content: input, isMe: true });

    setMessages(temp);
    setIsWriting(true);
    setInput("");
    setTips(null);

    setTimeout(() => {
      socket.emit("message", input);
    }, 1000);
    setTimeout(() => {
      setIsWriting(false);
    }, 2000);
  };

  return (
    <>
      <div
        className={
          styles.chatContainer + (isOpen ? " " + styles.openContainer : "")
        }
      >
        <div className={styles.headerChat}>
          <div>

            <div className={styles.list}>
              <div className={styles.avatar} onClick={() => setRoom("Axel")}>
                {
                    isOpen && <Image src='/img/chat.webp' layout="fill" alt="avatar"/>

                }
              </div>
            </div>
            <div className={styles.botAnim} onClick={() => setRoom("default")}>
              <Image
                  src={botImage}
                  width={"50px"}
                  height={"50px"}
                  alt="avatar"
              />
            </div>
          </div>
          <div
              className={styles.close}
              onClick={() => {
                setisOpen(false);
                traking({
                  eventName: "closeChat",
                  eventAction: "click",
                });
              }}
          >
            <div className={styles.cross}></div>
          </div>
        </div>
        {room == "default" ? (
          <>
            <div className={styles.bodyChat}>
              <div ref={messageListRef} className={styles.messageList}>
                {messages.map((msg, i) => {
                  return (
                    <div
                      key={i}
                      className={
                        msg.info
                          ? styles.infoMessage
                          : styles.messageContainer +
                            (msg.isMe ? " " + styles.myMessage : "")
                      }
                    >
                      <div className={styles.msgBu}></div>
                      <span>{msg.content}</span>
                    </div>
                  );
                })}
                {isWritting ? (
                  <div
                    className={styles.isWriting + " " + styles.messageContainer}
                    style={{ width: "25%" }}
                  >
                    <TypingLoader />
                  </div>
                ) : null}
                <span ref={bottomRef}></span>
              </div>
            </div>
            <form className={styles.formChat} onSubmit={handleSubmit}>
              <input
                type="text"
                name="msg"
                autoComplete="off"
                className={styles.inputText}
                id="msg"
                placeholder={tips ? tips : "Ecrivez à Carlos"}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                disabled={socket == null}
              />
              <input
                className={styles.submit}
                type="submit"
                value="Envoyer"
                onClick={() => {
                  traking({
                    eventName: "sendChatMessage",
                    eventAction: "click",
                  });
                }}
              />
            </form>
          </>
        ) : (
          <FormMail room={room} />
        )}
      </div>
      <div
        className={styles.openButton}
        onClick={() => {
          setisOpen(true);
          traking({
            eventName: "openChat",
            eventAction: "click",
          });
        }}
      >
        <div>
          <Image src={chatImage} alt="chat-button" layout="fill" />
        </div>
      </div>
    </>
  );
};

export default ChatContainer;
